import { RootState } from "../../store";

export const getApplicationFeatures = ({ application }: RootState) => {
  return application.features;
};
